module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_01.6bdbc8ed.jpg";